class Wishlist {
  constructor() {
    this.key = 'bullet_wishlist';
    this.items = this.load(); // array of { id, handle }
    this.init();
  }

  load() {
    try {
      const data = JSON.parse(localStorage.getItem(this.key)) || [];
      // Backward-compat: if old format (array of id strings) exists, convert
      return data.map(item => typeof item === 'string' ? { id: item, handle: null } : item);
    } catch (e) {
      return [];
    }
  }

  save() {
    localStorage.setItem(this.key, JSON.stringify(this.items));
    this.updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.items }));
  }

  toggle(id, handle) {
    id = String(id);
    const exists = this.items.some(i => i.id === id);
    if (exists) {
      this.items = this.items.filter(i => i.id !== id);
    } else {
      this.items.push({ id, handle });
    }
    this.save();
    return !exists;
  }

  remove(id) {
    id = String(id);
    this.items = this.items.filter(i => i.id !== id);
    this.save();
  }

  has(id) {
    return this.items.some(i => i.id === String(id));
  }

  updateCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = this.items.length;
      el.classList.toggle('wl-hidden', this.items.length === 0);
    });
  }

  syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const id = btn.dataset.productId;
      btn.classList.toggle('is-active', this.has(id));
    });
  }

  init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.productId;
      const handle = btn.dataset.productHandle;
      const added = this.toggle(id, handle);
      btn.classList.toggle('is-active', added);

      btn.classList.add('is-popping');
      setTimeout(() => btn.classList.remove('is-popping'), 300);
    });

    this.syncButtons();
    this.updateCount();

    document.addEventListener('wishlist:updated', () => this.syncButtons());

    window.addEventListener('storage', (e) => {
      if (e.key === this.key) {
        this.items = this.load();
        this.syncButtons();
        this.updateCount();
      }
    });

    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        this.items = this.load();
        this.syncButtons();
        this.updateCount();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist();
});